import type { ComponentProps } from 'react';
import { OwcComponentFooter } from '@one/react';

export type PocComponentFooterProps = ComponentProps<typeof OwcComponentFooter>;

export const PocComponentFooter: React.FC<PocComponentFooterProps> = (props) => <OwcComponentFooter {...props} />;
